import { useState, useCallback } from "react";
import "./css/index.css";

type Props = {
  FillterType: string;
};

function FillterCheck({ FillterType }: Props) {
  const [ischeck, setIsCheck] = useState<undefined>(undefined);

  const toggleActive = useCallback(
    (e: any) => {
      setIsCheck((prev) => {
        return e.target.value;
      });
    },
    [setIsCheck]
  );

  return (
    <div className="fillter-check">
      <div className="title">상태</div>
      {FillterType === "type" ? (
        <div className="check">
          {type.map((item: any, index: any) => {
            return (
              <div key={index} className="box">
                <button className="check" onClick={toggleActive} value={index}>
                  {ischeck == index ? (
                    <img src="/assets/common/custom.svg" alt="" />
                  ) : undefined}
                </button>
                {item.text}
              </div>
            );
          })}
        </div>
      ) : FillterType === "report" ? (
        <div className="check">
          {typeReport.map((item: any, index: any) => {
            return (
              <div key={index} className="box">
                <button className="check" onClick={toggleActive} value={index}>
                  {ischeck == index ? (
                    <img src="/assets/common/custom.svg" alt="" />
                  ) : undefined}
                </button>
                {item.text}
              </div>
            );
          })}
        </div>
      ) : undefined}
    </div>
  );
}

export default FillterCheck;

const type = [
  {
    text: "전체",
  },
  {
    text: "블라인드",
  },
  {
    text: "노출",
  },
];

const typeReport = [
  {
    text: "팀프로젝트 > 문의하기",
    type: "",
  },
  {
    text: "팀프로젝트 > 후기",
  },
  {
    text: "팀밋업 > 문의하기체",
  },
  {
    text: "팀밋업 > 후기",
  },
  {
    text: "추천평",
  },
  {
    text: "마이팀플 > 공지사항",
  },
  {
    text: "마이팀플 > 팀플룸",
  },
];
